import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@types-lib';
import { ClinicEnvironment, ENVIRONMENT } from 'environments';

export class LoginEndpoint {
  private env = inject<ClinicEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  post(credentials: Auth.AuthPostRequest) {
    return this.httpClient.post<Auth.AuthPostResponse>(
      `${this.env.constants.api_url}users/me/authenticate`,
      credentials,
      { withCredentials: true },
    );
  }

  // removes token
  delete() {
    return this.httpClient.delete<void>(`${this.env.constants.api_url}users/me/authenticate`);
  }
}
